'use strict';

/*
  Diretiva para criar tooltip utilizando a biblioteca Tipped
  http://www.tippedjs.com/
*/

angular.module('webAgro1App').directive('tipped', function($templateCache, $compile) {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      var content = attrs.tippedTemplate ? $compile($templateCache.get(attrs.tippedTemplate))(scope) : attrs.tippedContent;
      var options = {
        position: attrs.tippedPosition,
        behavior: attrs.tippedBehavior
      };

      Tipped.create(element, content, options);
    }
  };
});
